import dayjs, { Dayjs } from "dayjs"
import { TimeOnly } from "../@client/System"
import { Text, TextProps } from "@mantine/core"

interface Props extends TextProps {
  start: TimeOnly | null
  end: TimeOnly | null
}

export function TimeIsZero(date: Dayjs) {
  return date.hour() === 0 && date.minute() === 0
}

export function Period({ start, end, ...props }: Props) {
  return (
    <Text {...props}>
      {start && !TimeIsZero(dayjs(start)) ? start.slice(0, 5) : null}
      {end && !TimeIsZero(dayjs(end)) ? `-${end.slice(0, 5)}` : null}
    </Text>
  )
}
interface Props1 extends TextProps {
  start: Dayjs | null
  end: Dayjs | null
}

export function TimePeriodFromDayJS({ start, end, ...props }: Props1) {
  return (
    <Text {...props}>
      {start && !TimeIsZero(start) ? start.format("HH:mm") : null}
      {start && !TimeIsZero(start) && end && !TimeIsZero(end) ? "-" : null}
      {end && !TimeIsZero(end) ? end.format("HH:mm") : null}
    </Text>
  )
}
